import { render, staticRenderFns } from "./HomePageRecentlyViewed.vue?vue&type=template&id=02574d98&scoped=true"
import script from "./HomePageRecentlyViewed.vue?vue&type=script&lang=js"
export * from "./HomePageRecentlyViewed.vue?vue&type=script&lang=js"
import style0 from "./HomePageRecentlyViewed.vue?vue&type=style&index=0&id=02574d98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02574d98",
  null
  
)

export default component.exports